import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Client-side navigation preserves scroll position, so without this a visitor
 * clicking from halfway down the Rules page lands halfway down the next one.
 * Jumps instantly rather than smooth-scrolling: a route change should feel
 * like arriving, not travelling.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
